// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"PicturesPatient_gridContainer__2rGfr","imgPreview":"PicturesPatient_imgPreview__s2vKh"};